module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_1.c6d3ef41.png";